// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1lzCy","dropdown":"_23gSS","revamped":"_2A1MY","slideIn":"_2woF7"};